import React, { useMemo, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { ChromeContext } from './ChromeContext';
import { TopBarContent } from './TopBar';
import { MobileTitleBarContent } from '../surface/MobileTitleBar';
import MobileTabBar from '../MobileTabBar';
import CallMiniBar from '../calls/CallMiniBar';
import './appChrome.css';

export default function AppChrome() {
  const { pathname } = useLocation();
  const [header, setHeader] = useState(null);
  const host = useMemo(() => ({ setHeader }), []);
  return (
    <ChromeContext.Provider value={host}>
      <div data-pr-chrome className="sticky top-0 z-40">
        {/* A minimized voice call on a phone sits ABOVE the header and pushes it down. */}
        <CallMiniBar />
        {header?.kind === 'top' && <TopBarContent {...header.props} />}
        {header?.kind === 'title' && <MobileTitleBarContent {...header.props} />}
      </div>
      <div data-pr-content><Outlet key={pathname} /></div>
      <MobileTabBar />
    </ChromeContext.Provider>
  );
}
